var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityTypeConfigurationHelper } from '../models/basics/basics.models';
import { autoinject } from 'aurelia-dependency-injection';
import { BaseQueryWidgetConfiguration } from './base-widget';
import { transient } from 'aurelia-dependency-injection';
import { DataType } from "../models/queries/queries.models";
import { QueriesClientService } from "../services/queries/queries-client.services";
import * as Enumerable from "linq";
import { CustomGaugeConfig } from "../views/components/chart/custom-gauge-config.model";
var GaugeWidgetConfiguration = /** @class */ (function (_super) {
    __extends(GaugeWidgetConfiguration, _super);
    function GaugeWidgetConfiguration(entityTypeConfigurationHelper, queriesService) {
        var _this = _super.call(this, entityTypeConfigurationHelper) || this;
        _this.queriesService = queriesService;
        return _this;
    }
    GaugeWidgetConfiguration.prototype.entityTypeChanged = function () {
        var _this = this;
        this.queriesService.getNameProperties(this.entityTypeUri.replace(/ /g, ''))
            .then(function (nameProperties) {
            _this.aggrigationProperty = null;
            _this.aggrigationProperties = [];
            if (nameProperties && Enumerable.from(nameProperties).any(function (x) { return x.type == DataType.Number || x.type == DataType.Double; }))
                _this.aggrigationProperties.push({ name: "", friendlyName: " ", showByDefault: true, type: DataType.Default, format: "{0}", defaultOrdering: -1, isNullable: true, isDynamicProperty: true });
            _this.aggrigationProperties = _this.aggrigationProperties.concat(Enumerable.from(nameProperties).where(function (x) { return x.type == DataType.Number || x.type == DataType.Double; }).toArray());
            if (_this.model.aggrigationProperty) {
                _this.aggrigationProperty = _this.aggrigationProperties.filter(function (x) { return x.name == _this.model.aggrigationProperty.name; })[0];
            }
        });
        _super.prototype.entityTypeChanged.call(this);
    };
    GaugeWidgetConfiguration.prototype.getModel = function (self) {
        var queryFilters = self.queryEditor.selectedFilters;
        var model = {
            columns: self.queryEditor.columns,
            title: self.title,
            queryFilters: queryFilters,
            entityTypeUri: self.entityTypeUri,
            selectedSavedQueryId: self._queryEditor.selectedSavedQuery ? self._queryEditor.selectedSavedQuery.queryId : -1,
            gaugeUserConfigModel: self.gaugeConfig,
            target: this.target,
            description: self.description,
            aggrigationProperty: self.aggrigationProperty
        };
        return model;
    };
    GaugeWidgetConfiguration.prototype.setModelOverride = function (model) {
        this.target = model.target;
        this.description = model.description;
        if (this.aggrigationProperties && model.aggrigationProperty) {
            this.aggrigationProperty = this.aggrigationProperties.filter(function (x) { return x.name == model.aggrigationProperty.name; })[0];
        }
    };
    Object.defineProperty(GaugeWidgetConfiguration.prototype, "defaultConfig", {
        get: function () {
            return CustomGaugeConfig.setUserConfigModelDefaults({});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GaugeWidgetConfiguration.prototype, "gaugeConfig", {
        get: function () {
            return this._gaugeConfig;
        },
        set: function (customGaugeConfig) {
            if (customGaugeConfig) {
                this._gaugeConfig = customGaugeConfig;
            }
            else {
                this._gaugeConfig = this.defaultConfig;
            }
        },
        enumerable: false,
        configurable: true
    });
    GaugeWidgetConfiguration = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EntityTypeConfigurationHelper, QueriesClientService])
    ], GaugeWidgetConfiguration);
    return GaugeWidgetConfiguration;
}(BaseQueryWidgetConfiguration));
export { GaugeWidgetConfiguration };
